/**
 * @generated SignedSource<<60bee664ada02a8023043b9b68967caf>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ZakekeEnvironment = "COMPOSER" | "CUSTOMIZER" | "UNKNOWN" | "VIEWER";
export type QuickAccessMenuInput = {
  environment: ZakekeEnvironment;
  keys: ReadonlyArray<string>;
};
export type StarredMenuSaveMutation$variables = {
  input: QuickAccessMenuInput;
};
export type StarredMenuSaveMutation$data = {
  readonly saveQuickAccessMenu: {
    readonly keys: ReadonlyArray<string>;
  };
};
export type StarredMenuSaveMutation = {
  response: StarredMenuSaveMutation$data;
  variables: StarredMenuSaveMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "QuickAccessMenu",
    "kind": "LinkedField",
    "name": "saveQuickAccessMenu",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "keys",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "StarredMenuSaveMutation",
    "selections": (v1/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "StarredMenuSaveMutation",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "cacheID": "c9a22baaecaddb18c6d746fd6ffcc7d5",
    "id": null,
    "metadata": {},
    "name": "StarredMenuSaveMutation",
    "operationKind": "mutation",
    "text": "mutation StarredMenuSaveMutation(\n  $input: QuickAccessMenuInput!\n) {\n  saveQuickAccessMenu(input: $input) {\n    keys\n  }\n}\n"
  }
};
})();

(node as any).hash = "5988d62ae4a323ceb9488b29ebe5148b";

export default node;
